import { cerrarSesion } from "./session.js";

import { arrancarDespuesDeLogin } from "./session.js";
import { C } from "../core/config.js";
import { state } from "../core/state.js";
import { supa } from "../core/supabaseClient.js";
import { btnStyle, escapeHTML, inputStyle } from "../core/utils.js";
import { render } from "../ui/app.js";

export function renderModalMFA() {
  const factores = state._mfaFactores || [];
  const verificado = factores.find(f => f.status === "verified");

  const cuerpo = state._mfaEnroll ? `
    <div style="text-align:center;margin-bottom:16px;">
      <img src="${state._mfaEnroll.qr}" alt="Código QR" style="width:180px;height:180px;margin:0 auto;display:block;border:1px solid ${C.border};border-radius:8px;"/>
      <div style="font-size:11px;color:${C.muted};margin-top:8px;">Escanea el código con <strong>Microsoft Authenticator</strong> (o Google Authenticator / Authy).</div>
      <div style="font-size:10px;color:${C.muted};margin-top:4px;word-break:break-all;">O ingresa manualmente: <strong>${escapeHTML(state._mfaEnroll.secret)}</strong></div>
    </div>
    <div style="margin-bottom:14px;">
      <label style="font-size:11px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Código de 6 dígitos</label>
      <input id="mfa-codigo" type="text" inputmode="numeric" maxlength="6" placeholder="000000" style="${inputStyle}text-align:center;letter-spacing:4px;font-size:18px;"/>
    </div>
    <div style="display:flex;gap:10px;justify-content:flex-end;">
      <button data-action="mfa-cancelar-enroll" style="${btnStyle(null,"secondary")}">Cancelar</button>
      <button data-action="mfa-confirmar-enroll" style="${btnStyle("#10b981")}">Confirmar y activar</button>
    </div>
  ` : verificado ? `
    <div style="background:#d1fae5;border:1px solid #86efac;border-radius:10px;padding:14px;margin-bottom:16px;">
      <div style="font-weight:700;color:#065f46;font-size:13px;">✅ Verificación en dos pasos activa</div>
      <div style="font-size:11px;color:#047857;margin-top:2px;">Desde tu próximo inicio de sesión te pediremos el código de tu app autenticadora.</div>
    </div>
    <div style="display:flex;justify-content:flex-end;">
      <button data-action="mfa-quitar-factor" data-id="${verificado.id}" style="${btnStyle("#dc2626")}">Desactivar</button>
    </div>
  ` : `
    <div style="background:#fef3c7;border:1px solid #fcd34d;border-radius:10px;padding:14px;margin-bottom:16px;">
      <div style="font-weight:700;color:#92400e;margin-bottom:4px;">⚠️ Sin verificación en dos pasos</div>
      <div style="font-size:12px;color:#78350f;">Tu cuenta solo está protegida por contraseña. Actívala para que, aunque alguien conozca tu contraseña, no pueda iniciar sesión sin el código de tu teléfono.</div>
    </div>
    <div style="display:flex;justify-content:flex-end;">
      <button data-action="mfa-iniciar-enroll" style="${btnStyle(C.mathiz)}">Activar verificación en dos pasos</button>
    </div>
  `;

  return `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:420px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:16px 20px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">🔐 Verificación en dos pasos</h3>
          <button data-action="close-modal" style="background:transparent;border:none;font-size:22px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <div style="padding:20px;">
          ${cuerpo}
        </div>
      </div>
    </div>
  `;
}

export async function abrirSeguridadMFA() {
  const { data, error } = await supa.auth.mfa.listFactors();
  if (error) { alert("⚠️ No se pudo consultar la verificación en dos pasos: " + error.message); return; }
  state._mfaFactores = data.totp || [];
  state._mfaEnroll = null;
  state.modal = renderModalMFA();
  render();
}

export async function iniciarEnrollMFA() {
  await limpiarFactoresSinVerificar();
  // friendlyName único: Supabase rechaza dos factores con el mismo nombre, y
  // un residuo con nombre vacío de un intento anterior dejaba el enroll
  // chocando en silencio — el QR nunca aparecía.
  const { data, error } = await supa.auth.mfa.enroll({ factorType: "totp", friendlyName: "Authenticator " + Date.now() });
  if (error) { alert("⚠️ " + error.message); return; }
  state._mfaEnroll = { factorId: data.id, qr: data.totp.qr_code, secret: data.totp.secret };
  state.modal = renderModalMFA();
  render();
}

export async function confirmarEnrollMFA() {
  const input = document.getElementById("mfa-codigo");
  const codigo = (input ? input.value : "").trim();
  if (!codigo) { alert("Ingresa el código de 6 dígitos de tu app autenticadora."); return; }
  const factorId = state._mfaEnroll.factorId;
  const { data: challenge, error: errC } = await supa.auth.mfa.challenge({ factorId });
  if (errC) { alert("⚠️ " + errC.message); return; }
  const { error: errV } = await supa.auth.mfa.verify({ factorId, challengeId: challenge.id, code: codigo });
  if (errV) { alert("⚠️ Código incorrecto o expirado: " + errV.message); return; }
  state._mfaEnroll = null;
  state.modal = null;
  await guardarDispositivoConfiable(); // este navegador queda de confianza desde ya
  alert("✅ Verificación en dos pasos activada. En dispositivos nuevos (o cada 15 días) te pediremos el código.");
  render();
}

export async function quitarFactorMFA(factorId) {
  if (!confirm("¿Desactivar la verificación en dos pasos? Volverás a iniciar sesión solo con tu contraseña.")) return;
  const { error } = await supa.auth.mfa.unenroll({ factorId });
  if (error) { alert("⚠️ " + error.message); return; }
  state.modal = null;
  alert("Verificación en dos pasos desactivada.");
  render();
}

export function renderPantallaMFAChallenge(userId) {
  const root = document.getElementById("root");
  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle at 30% 20%,#0B132B 0%,${C.mathiz} 45%,#0B132B 100%);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;padding:20px;">
      <div style="background:white;border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.35);max-width:440px;width:100%;overflow:hidden;">
        <div style="height:5px;background:linear-gradient(90deg,${C.gold},${C.mathiz});"></div>
        <div style="padding:40px 36px 36px;">
          <div style="text-align:center;margin-bottom:26px;">
            <div style="font-size:40px;margin-bottom:10px;">🔐</div>
            <h2 style="margin:0 0 6px;font-size:18px;color:${C.text};">Verificación en dos pasos</h2>
            <p style="color:#6b7280;font-size:13px;margin:0;">Ingresa el código de 6 dígitos de Microsoft Authenticator (o tu app autenticadora).</p>
            <p style="color:#94a3b8;font-size:11px;margin:8px 0 0;">No volveremos a pedirlo en este dispositivo durante los próximos 15 días.</p>
          </div>
          <div style="margin-bottom:20px;">
            <input id="__mfa_codigo" type="text" inputmode="numeric" maxlength="6" placeholder="000000" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:20px;text-align:center;letter-spacing:6px;"/>
          </div>
          <button id="__mfa_btn" style="width:100%;background:linear-gradient(135deg,${C.mathiz},#0B132B);color:white;border:none;padding:12px;border-radius:8px;font-weight:700;font-size:14px;cursor:pointer;letter-spacing:.3px;">Verificar</button>
          <div id="__mfa_status" style="text-align:center;margin-top:14px;font-size:12px;color:#6b7280;"></div>
        </div>
      </div>
    </div>
  `;
  document.getElementById("__mfa_btn").addEventListener("click", () => verificarMFALogin(userId));
  document.getElementById("__mfa_codigo").addEventListener("keydown", e => { if (e.key === "Enter") verificarMFALogin(userId); });
}

let _mfaObligFactorId = null;

// Pantalla de enrolamiento OBLIGATORIO: se muestra cuando el rol del usuario
// exige MFA (ROLES_MFA_OBLIGATORIO) y todavía no tiene ningún factor
// verificado. A diferencia del modal de "Seguridad" (opcional, se puede
// cerrar), esta pantalla reemplaza el contenido completo y no se puede
// saltar — solo permite cerrar sesión.
export function renderPantallaMFAObligatorio(userId) {
  const root = document.getElementById("root");
  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle at 30% 20%,#0B132B 0%,${C.mathiz} 45%,#0B132B 100%);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;padding:20px;">
      <div style="background:white;border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.35);max-width:460px;width:100%;overflow:hidden;">
        <div style="height:5px;background:linear-gradient(90deg,${C.gold},${C.mathiz});"></div>
        <div style="padding:40px 36px 36px;">
          <div style="text-align:center;margin-bottom:20px;">
            <div style="font-size:40px;margin-bottom:10px;">🔐</div>
            <h2 style="margin:0 0 6px;font-size:18px;color:${C.text};">Verificación en dos pasos obligatoria</h2>
            <p style="color:#6b7280;font-size:13px;margin:0;">Por seguridad, todas las cuentas deben activar la verificación en dos pasos antes de continuar. Escanea el código con <strong>Microsoft Authenticator</strong> (o Google Authenticator / Authy).</p>
          </div>
          <div id="__mfa_oblig_qr_wrap" style="text-align:center;margin-bottom:16px;">
            <div style="font-size:12px;color:#6b7280;">Generando código…</div>
          </div>
          <div style="margin-bottom:16px;">
            <input id="__mfa_oblig_codigo" type="text" inputmode="numeric" maxlength="6" placeholder="000000" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:20px;text-align:center;letter-spacing:6px;"/>
          </div>
          <button id="__mfa_oblig_btn" style="width:100%;background:linear-gradient(135deg,${C.mathiz},#0B132B);color:white;border:none;padding:12px;border-radius:8px;font-weight:700;font-size:14px;cursor:pointer;letter-spacing:.3px;">Confirmar y activar</button>
          <div id="__mfa_oblig_status" style="text-align:center;margin-top:14px;font-size:12px;color:#6b7280;"></div>
          <div style="text-align:center;margin-top:16px;">
            <button id="__mfa_oblig_salir" style="background:transparent;border:none;color:#94a3b8;font-size:12px;cursor:pointer;text-decoration:underline;">Cerrar sesión</button>
          </div>
        </div>
      </div>
    </div>
  `;
  document.getElementById("__mfa_oblig_salir").addEventListener("click", () => cerrarSesion());
  iniciarEnrollMFAObligatorio(userId);
}

// ─── Dispositivos de confianza ───────────────────────────────────────────────
// Tras superar un reto MFA real, la Edge Function "mfa-dispositivo" emite un
// token firmado (HMAC, 15 días) que se guarda en localStorage: mientras sea
// válido, el login omite el código en ESTE navegador. La clave NO está en
// CONFIG_CLOUD_KEYS, así que no se sincroniza a la nube — la confianza es
// genuinamente por dispositivo.
const DISPOSITIVO_CONFIABLE_PREFIX = "mathiz_disp_confiable:";

export async function guardarDispositivoConfiable() {
  try {
    const { data: { user } } = await supa.auth.getUser();
    if (!user) return;
    const { data, error } = await supa.functions.invoke("mfa-dispositivo", { body: { accion: "emitir" } });
    if (error || !data?.token) return; // no bloquea el login: solo pedirá código la próxima vez
    localStorage.setItem(DISPOSITIVO_CONFIABLE_PREFIX + user.id, data.token);
  } catch { /* idem */ }
}

export async function dispositivoEsConfiable(userId) {
  try {
    const token = localStorage.getItem(DISPOSITIVO_CONFIABLE_PREFIX + userId);
    if (!token) return false;
    const { data, error } = await supa.functions.invoke("mfa-dispositivo", { body: { accion: "validar", token } });
    if (error) return false; // ante cualquier duda, pedir el código (comportamiento seguro)
    if (!data?.valido) {
      localStorage.removeItem(DISPOSITIVO_CONFIABLE_PREFIX + userId); // vencido o ajeno: limpiar
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

// Si quedó un factor TOTP a medio registrar de un intento anterior (p.ej. se
// recargó la página sin confirmar el código), hay que eliminarlo antes de
// enrolar de nuevo: Supabase rechaza un segundo enroll con el mismo nombre y
// el secreto/QR del intento anterior no se puede volver a mostrar.
async function limpiarFactoresSinVerificar() {
  try {
    const { data } = await supa.auth.mfa.listFactors();
    for (const f of (data?.totp || [])) {
      if (f.status !== "verified") {
        try { await supa.auth.mfa.unenroll({ factorId: f.id }); } catch { /* continuar con los demás */ }
      }
    }
  } catch { /* si no se puede listar, el enroll reportará el error real */ }
}

async function iniciarEnrollMFAObligatorio(userId) {
  await limpiarFactoresSinVerificar();
  // friendlyName único: Supabase rechaza dos factores con el mismo nombre, y
  // un residuo con nombre vacío de un intento anterior dejaba el enroll
  // chocando en silencio — el QR nunca aparecía.
  const { data, error } = await supa.auth.mfa.enroll({ factorType: "totp", friendlyName: "Authenticator " + Date.now() });
  const wrap = document.getElementById("__mfa_oblig_qr_wrap");
  if (error) {
    if (wrap) wrap.innerHTML = `<div style="color:#dc2626;font-size:12px;">⚠️ ${escapeHTML(error.message)}</div>`;
    return;
  }
  _mfaObligFactorId = data.id;
  if (wrap) {
    wrap.innerHTML = `
      <img src="${data.totp.qr_code}" alt="Código QR" style="width:180px;height:180px;margin:0 auto;display:block;border:1px solid ${C.border};border-radius:8px;"/>
      <div style="font-size:10px;color:${C.muted};margin-top:8px;word-break:break-all;">O ingresa manualmente: <strong>${escapeHTML(data.totp.secret)}</strong></div>
    `;
  }
  const btn = document.getElementById("__mfa_oblig_btn");
  if (btn) btn.addEventListener("click", () => confirmarEnrollMFAObligatorio(userId));
  const input = document.getElementById("__mfa_oblig_codigo");
  if (input) input.addEventListener("keydown", e => { if (e.key === "Enter") confirmarEnrollMFAObligatorio(userId); });
}

async function confirmarEnrollMFAObligatorio(userId) {
  const input = document.getElementById("__mfa_oblig_codigo");
  const statusEl = document.getElementById("__mfa_oblig_status");
  const btn = document.getElementById("__mfa_oblig_btn");
  const codigo = (input ? input.value : "").trim();
  if (!codigo) { statusEl.textContent = "Ingresa el código de 6 dígitos."; return; }
  if (!_mfaObligFactorId) { statusEl.textContent = "No se pudo generar el factor. Recarga la página."; return; }
  btn.disabled = true; btn.textContent = "Verificando…"; statusEl.textContent = "";

  const { data: challenge, error: errC } = await supa.auth.mfa.challenge({ factorId: _mfaObligFactorId });
  if (errC) { statusEl.textContent = "Error: " + errC.message; btn.disabled = false; btn.textContent = "Confirmar y activar"; return; }

  const { error: errV } = await supa.auth.mfa.verify({ factorId: _mfaObligFactorId, challengeId: challenge.id, code: codigo });
  if (errV) {
    statusEl.textContent = "Código incorrecto o expirado.";
    btn.disabled = false; btn.textContent = "Confirmar y activar";
    return;
  }
  await guardarDispositivoConfiable(); // el enrolamiento cuenta como reto superado
  await arrancarDespuesDeLogin(userId);
}

export async function verificarMFALogin(userId) {
  const input = document.getElementById("__mfa_codigo");
  const statusEl = document.getElementById("__mfa_status");
  const btn = document.getElementById("__mfa_btn");
  const codigo = (input ? input.value : "").trim();
  if (!codigo) { statusEl.textContent = "Ingresa el código de 6 dígitos."; return; }
  btn.disabled = true; btn.textContent = "Verificando..."; statusEl.textContent = "";

  const { data: factores, error: errF } = await supa.auth.mfa.listFactors();
  if (errF) { statusEl.textContent = "Error: " + errF.message; btn.disabled = false; btn.textContent = "Verificar"; return; }
  const factor = (factores.totp || []).find(f => f.status === "verified");
  if (!factor) { statusEl.textContent = "No se encontró un factor de verificación activo."; btn.disabled = false; btn.textContent = "Verificar"; return; }

  const { data: challenge, error: errC } = await supa.auth.mfa.challenge({ factorId: factor.id });
  if (errC) { statusEl.textContent = "Error: " + errC.message; btn.disabled = false; btn.textContent = "Verificar"; return; }

  const { error: errV } = await supa.auth.mfa.verify({ factorId: factor.id, challengeId: challenge.id, code: codigo });
  if (errV) {
    statusEl.textContent = "Código incorrecto. Intenta de nuevo.";
    btn.disabled = false; btn.textContent = "Verificar";
    return;
  }
  await guardarDispositivoConfiable();
  await arrancarDespuesDeLogin(userId);
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "cerrar-sesion": (d, el, e) => {cerrarSesion();
      return;},
  "abrir-seguridad-mfa": (d, el, e) => {abrirSeguridadMFA();
      return;},
  "mfa-iniciar-enroll": (d, el, e) => {iniciarEnrollMFA();
      return;},
  "mfa-confirmar-enroll": (d, el, e) => {confirmarEnrollMFA();
      return;},
  "mfa-cancelar-enroll": (d, el, e) => {state._mfaEnroll = null;
      state.modal = renderModalMFA();
      render();
      return;},
  "mfa-quitar-factor": (d, el, e) => {quitarFactorMFA(d.id);
      return;},
});
